import { render, staticRenderFns } from "./CreateBackupServer.vue?vue&type=template&id=cc373230&"
import script from "./CreateBackupServer.vue?vue&type=script&lang=ts&"
export * from "./CreateBackupServer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports